
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aL23w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $113a14f6b780efe1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $kGR8U = parcelRequire("kGR8U");

var $4cTDP = parcelRequire("4cTDP");

var $31y1Z = parcelRequire("31y1Z");

const $113a14f6b780efe1$var$AfterPaintIssuePreEval = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $31y1Z.PREEVAL_ROUTES).has(route.name) && (!(0, $4cTDP.fg)('spike_removing_lazyissueapp_from_nin_routes') || !(0, $31y1Z.EXCLUDE_PREEVAL_ROUTES).has(route.name)) && !(0, $31y1Z.EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES).has(route.name)) {
            (()=>{
                (0, $kGR8U.markAsBentoBundleReady)((parcelRequire("lOoQA")));
            })();
            performance.mark((0, $31y1Z.AFTER_PAINT_ISSUE_PREEVAL_MARK));
        }
    }, [
        route.name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
var $113a14f6b780efe1$export$2e2bcd8739ae039 = $113a14f6b780efe1$var$AfterPaintIssuePreEval;

});
parcelRegister("kGR8U", function(module, exports) {
$parcel$export(module.exports, "markAsBentoBundleReady", () => $393e398983932379$export$d9ff0b3329728986);

var $75yrv = parcelRequire("75yrv");

var $lOI8W = parcelRequire("lOI8W");
let $393e398983932379$var$reportedBentoBundleReady = false;
const $393e398983932379$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($393e398983932379$var$reportedBentoBundleReady) return;
        $393e398983932379$var$reportedBentoBundleReady = true;
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("31y1Z", function(module, exports) {
$parcel$export(module.exports, "PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$8411da1302b7546c);
$parcel$export(module.exports, "EXCLUDE_PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$bd0ce8e012b9a3e4);
$parcel$export(module.exports, "EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$53724bb7236bede3);
$parcel$export(module.exports, "AFTER_PAINT_ISSUE_PREEVAL_MARK", () => $54ce935e6d4d4d0c$export$76f8f9afcfc4a896);
const $54ce935e6d4d4d0c$export$8411da1302b7546c = new Set([
    'archived-projects-directory',
    'archived-project-direct-link',
    'boards-directory',
    'classic-business-board',
    'classic-business-board-embed',
    'classic-business-board-custom-embed',
    'classic-business-calendar',
    'classic-business-calendar-embed',
    'classic-business-calendar-custom-embed',
    'classic-business-form',
    'classic-business-form-submit',
    'classic-business-list',
    'classic-business-list-embed',
    'classic-business-timeline',
    'classic-business-timeline-embed',
    'connect-general',
    'connect-general-invalid',
    'connect-general-service-desk-project',
    'connect-project',
    'dashboards-directory',
    'dashboards-directory-secure',
    'filters-directory',
    'forge-spa-admin',
    'global-issue-navigator',
    'global-settings-issues-custom-fields-view',
    'global-settings-issues-fieldlayouts-view',
    'global-settings-issues-fieldlayouts-schemes-view',
    'global-settings-issues-linktypes-view',
    'global-settings-issues-notification-view',
    'global-settings-issues-permissions-schemes-view',
    'global-settings-issues-priorities',
    'global-settings-issues-resolutions',
    'global-settings-issues-security-schemes',
    'global-settings-issues-statuses',
    'global-settings-issues-field-schemes-view',
    'global-settings-issues-field-screens',
    'global-settings-issues-subtasks-manage',
    'global-settings-issues-time-tracking',
    'global-settings-issues-types-view',
    'global-settings-issues-types-schemes-manage',
    'global-settings-issues-types-screen-schemes-view',
    'global-settings-issues-workflows-pages',
    'global-settings-issues-workflows-schemes-view',
    'issue-embed',
    'knowledge-hub-all-articles',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'knowledge-hub-suggested-topics',
    'opsgenie-schedule',
    'people-index',
    'personal-settings',
    'polaris-ideas',
    'products-jsw-configuration',
    'projects-directory',
    'project-components',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'project-pages',
    'project-settings-components',
    'project-settings-versions',
    'project-versions',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-board-embed',
    'rapidboard-report',
    'rapidboard-user-backlog',
    'rapidboard-user-board',
    'rapidboard-user-report',
    'servicedesk-change-calendar',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-connect-project',
    'servicedesk-create-project',
    'servicedesk-customers-v2',
    'servicedesk-boards',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organization_v2',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-edit',
    'servicedesk-queues-issue',
    'servicedesk-queues-landing',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'servicedesk-sla-settings',
    'global-settings-issues-cmdb-field-config',
    'admin-oauth-credentials',
    'software-backlog',
    'software-boards',
    'software-code',
    'software-code-classic',
    'software-security',
    'software-security-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-issue-navigator',
    'software-release-notes',
    'software-reports',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-velocity',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline',
    'software-timeline-classic',
    'system-dashboard-edit',
    'trash-projects-directory',
    'your-work'
]);
const $54ce935e6d4d4d0c$export$bd0ce8e012b9a3e4 = new Set([
    'global-issue-navigator',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'servicedesk-issues',
    'software-issue-navigator',
    'software-timeline',
    'software-timeline-classic'
]);
const $54ce935e6d4d4d0c$export$53724bb7236bede3 = new Set([
    'software-backlog',
    'software-boards',
    'rapidboard-backlog',
    'rapidboard-board'
]);
const $54ce935e6d4d4d0c$export$76f8f9afcfc4a896 = 'AfterPaintIssuePreEval:rendered';

});

parcelRegister("lOoQA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("j53wu")
]).then(()=>parcelRequire('5IVSD'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});





//# sourceMappingURL=AfterPaintIssuePreEval.ab0ee09e.js.map
